import { HYPERION_API_DOMAIN } from "@/common/config";

export const BASE_URL = HYPERION_API_DOMAIN + "/hyperionapi";

// ENDPOINTS
export const ENDPOINT_CONFIG = BASE_URL + "/v1/config";
export const ENDPOINT_FEATURE_LOCK = BASE_URL + "/v1/featurelock";
export const ENDPOINT_WOD = BASE_URL + "/v1/wod";
export const ENDPOINT_WOD_MAP = BASE_URL + "/v1/map/wod";
export const ENDPOINT_NEWS = BASE_URL + "/v2/news";
export const ENDPOINT_NEWS_MAP = BASE_URL + "/v2/map/news";
export const ENDPOINT_SOCIAL = BASE_URL + "/v2/tweets";
export const ENDPOINT_SOCIAL_MAP = BASE_URL + "/v2/tweets/geohash";
export const ENDPOINT_GRIDS = BASE_URL + "/v2/pulse";
export const ENDPOINT_GRIDS_COUNTRY = BASE_URL + "/v2/pulse/country";
export const ENDPOINT_USER_PROFILE = BASE_URL + "/v2/user/profile";
export const ENDPOINT_USER_PREFERENCES = BASE_URL + "/v2/user/metadata";
export const ENDPOINT_USER_GROUP_MEMBERS = BASE_URL + "/v3/user/groups/members";
export const ENDPOINT_USER_GROUPS = BASE_URL + "/v2/user/groups";
export const ENDPOINT_USER_ACCEPT_EULA = BASE_URL + "/v2/user/accept-policy";
export const ENDPOINT_USER_ACCEPT_WELCOME =
  BASE_URL + "/v2/user/accept-welcome";
export const ENDPOINT_USER_MFA = BASE_URL + "/v2/user/mfa";
export const ENDPOINT_AOIS = BASE_URL + "/v1/aois";
export const ENDPOINT_SENTIMENT = BASE_URL + "/v2/sentiment";
export const ENDPOINT_TRANSLATOR = BASE_URL + "/v1/translate";
export const ENDPOINT_ALERTS = BASE_URL + "/v3/alerts";
export const ENDPOINT_ALERT_UNSUBSCRIBE = BASE_URL + "/v3/alerts/unsubscribe";
export const ENDPOINT_ALERTED_DATA = BASE_URL + "/v3/alerts/data";
export const ENDPOINT_SEMANTIC = BASE_URL + "/v1/semantic";
export const ENDPOINT_CUSTOM_LAYERS = BASE_URL + "/v1/custom-layers";
export const ENDPOINT_HOTSPOTS = BASE_URL + "/v1/hotspots";
export const ENDPOINT_HOTSPOTS_TOPIC = BASE_URL + "/v1/hotspots/topic";
export const ENDPOINT_HOTSPOTS_TOPIC_TOP = BASE_URL + "/v1/hotspots/topic/top";
export const ENDPOINT_TOPICS = BASE_URL + "/v1/topics";
export const ENDPOINT_TOPICS_CLUSTERING_CORRECTION =
  BASE_URL + "/v2/clusters/correction";
export const ENDPOINT_CLICK_STREAM = BASE_URL + "/v1/click-stream";
export const ENDPOINT_REGISTER_DEVICE =
  BASE_URL + "/v1/notifications/device/register";
export const ENDPOINT_UNREGISTER_DEVICE =
  BASE_URL + "/v1/notifications/device/unregister";
export const ENDPOINT_DASHBOARDS = BASE_URL + "/v1/dashboards";
export const ENDPOINT_SCRIBE = BASE_URL + "/v2/auto-summary";
export const ENDPOINT_SAVED_SEARCH = BASE_URL + "/v1/savedsearch";
export const ENDPOINT_TRAVEL_TRACKER_TRAVELERS =
  BASE_URL + "/v1/isos-traveler/travelers";
export const ENDPOINT_TRAVEL_TRACKER_PROFILE =
  BASE_URL + "/v1/isos-traveler/profile";
export const ENDPOINT_TRAVEL_TRACKER_PROFILES =
  BASE_URL + "/v1/isos-traveler/profiles";

// collaboration URLs
export const ENDPOINT_COLLABORATION_FOLDERS = BASE_URL + "/v1/collaboration";
export const ENDPOINT_COLLABORATION_EXPORT =
  BASE_URL + "/v1/collaboration/export";
export const ENDPOINT_COLLABORATION_SHARE =
  BASE_URL + "/v1/collaboration/share";
export const ENDPOINT_COLLABORATION_LINK = BASE_URL + "/v1/collaboration/link";

// communication URLs
export const ENDPOINT_COMMUNICATION = BASE_URL + "/v1/mass-notifications";

// assets URLs
export const ENDPOINT_ASSETS = BASE_URL + "/v1/assets";

// Power Outage
export const ENDPOINT_POWER_OUTAGE = BASE_URL + "/v1/power-outage/counties";

// Control Risks URLs
export const ENDPOINT_CR_INCIDENTS = HYPERION_API_DOMAIN + "/incidents";
export const CR_RISK_BASE_URL = HYPERION_API_DOMAIN + "/api";
export const ENDPOINT_CR_COUNTRIES = CR_RISK_BASE_URL + "/countries";
export const ENDPOINT_CR_RISK_RATINGS = CR_RISK_BASE_URL + "/riskRatings";
export const ENDPOINT_CR_RISK_CATEGORIES = CR_RISK_BASE_URL + "/riskCategories";
export const ENDPOINT_CR_UPDATES = CR_RISK_BASE_URL + "/updates";
export const ENDPOINT_CR_MAP_LAYERS = CR_RISK_BASE_URL + "/mapLayers";

// Internal CR Urls
export const ENDPOINT_RISK_CATEGORIES = BASE_URL + "/v1/config/risk-categories";

// static URLs
export const STATIC_RESOURCES_PATH = "/hyperion-v2-static";

export const PLACES_IMAGE_URL = STATIC_RESOURCES_PATH + "/places";

export const AOIS_JSON_PATH = STATIC_RESOURCES_PATH + "/aois";
export const CITIES_JSON_URL = AOIS_JSON_PATH + "/cities.json";
export const COUNTRIES_JSON_URL = AOIS_JSON_PATH + "/countries.json";
export const COUNTIES_JSON_URL = AOIS_JSON_PATH + "/counties-us.json";
export const REGIONS_JSON_URL = AOIS_JSON_PATH + "/crRegions.json";
